"use client"

import { useState } from "react"
import { supabase } from "@/lib/supabase"
import { OAUTH_REDIRECT_URL } from "@/lib/auth"

export function GoogleLoginButton() {
  const [error, setError] = useState<string | null>(null)

  const handleGoogleLogin = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: OAUTH_REDIRECT_URL,
      },
    })

    if (error) {
      console.error("Google login error:", error.message)
      setError("Google login failed. Try again.")
    }
  }

  return (
    <div className="w-full">
      <button
        onClick={handleGoogleLogin}
        className="w-full flex items-center justify-center gap-3 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-md text-white px-6 py-2.5 text-sm font-semibold transition-all border border-white/30 shadow-lg h-11"
      >
        <svg className="h-5 w-5" viewBox="0 0 48 48">
          <path fill="#fbc02d" d="M43.6 20.5H42V20H24v8h11.3C34.3 32.6 29.8 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l6-6C34.1 6.2 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.7-8 19.7-20 0-1.3-.1-2.2-.1-3.5z"/>
          <path fill="#e53935" d="M6.3 14.7l6.6 4.8C14.4 16.1 18.8 13 24 13c3.1 0 5.9 1.2 8 3.1l6-6C34.1 6.2 29.3 4 24 4c-7.7 0-14.4 3.4-18.7 8.7z"/>
          <path fill="#4caf50" d="M24 44c5.8 0 10.7-1.9 14.2-5.2l-6.6-5.4C29.8 36 26.4 37 24 37c-5.7 0-10.5-3.8-12.3-9l-6.5 5C9.6 39.8 16.2 44 24 44z"/>
          <path fill="#1565c0" d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.2-3.4 5.4-6.3 6.4l6.6 5.4c-2.3 2.1-5.3 3.2-8.6 3.2C16.2 43 9.6 39.8 5.2 33.1l6.5-5C13.5 33.2 18.3 37 24 37c2.4 0 5.8-1 7.6-3.1 1.3-1.5 2.1-3.4 2.4-5.5H24v-8h19.6z"/>
        </svg>
        <span>Continue with Google</span>
      </button>

      {error && (
        <div className="mt-2 rounded-full bg-red-500/10 border border-red-500/20 px-4 py-2 text-center">
          <p className="text-sm text-red-300">
            {error}
          </p>
        </div>
      )}
    </div>
  )
}
